import { i18n } from '@/utils/lang';
// import { post } from '@/utils/request';
import { MessagePlugin } from 'tdesign-vue-next';
import { fetchStatic, FETCH_LIST } from '@/hooks/hookUtils';
import axios from 'axios';

// 是否是本地环境
export function isDev() {
  return ['dev', 'local'].includes(process.env.NODE_ENV);
}
// 判断是否是英文站点
export function isEnSite() {
  return ['en-US'].includes(i18n.global.locale.value);
}
/**
 * 字符串驼峰格式化
 * @param {string} str
 * @returns {string}
 */
export function camelCase(str) {
  return str.toLowerCase().replace(/[-_\s]+(\w)/g, (re, $1) => $1.toUpperCase());
}

/**
 * 获取静态资源
 * @param {string} url 资源路径
 */
export function getResourceFile(url) {
  const urlPrefix = process.env.VUE_APP_STONE_JSON_URL;
  return axios.get(`${urlPrefix}/${url}`).then(({ data }) => data);
}
/** 延时函数 */
export function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}

/**
 * 判断一个日期是否无效
 * @param {Date} date
 */
export function isInvalidDate(date) {
  if (!(date instanceof Date)) return true;
  return date.toString() === 'Invalid Date';
}

// 通用的生成日期的方法
export function getDate(from) {
  if (!from) return null;

  if (typeof from === 'string') {
    let templ = from.replace(/-/g, '/').replace(/^(\d{4}\/\d{2})([^/]|$)/, (re, $1, $2) => [$1, '/01', $2].join(''));

    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(templ)) {
      templ = `${templ}:00`;
    }

    // 适配mac的safari浏览器
    const date = new Date(templ);
    return isInvalidDate(date) ? null : date;
  }

  if (Number.isInteger(from)) {
    switch (String(from).length) {
      case 10:
        return new Date(from * 1000);
      case 13:
        return new Date(from);
      default:
        return null;
    }
  }

  const date = new Date(from);
  return isInvalidDate(date) ? null : date;
}

// 深拷贝
export function deepCopy(source) {
  if (Array.isArray(source)) {
    return source.map((item) => deepCopy(item));
  }

  if (source instanceof Date) {
    return getDate(source);
  }

  if (typeof source === 'object' && source !== null) {
    const target = {};
    Object.keys(source).forEach((key) => {
      target[key] = deepCopy(source[key]);
    });
    return target;
  }

  return source;
}

// 比对两个对象是否不一致
export function checkDiff(obj1, obj2) {
  if (obj1 === obj2) return false;

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return true;
    return obj1.some((item, index) => checkDiff(item, obj2[index]));
  }

  if (obj1 && obj1.constructor && obj2 && obj2.constructor) {
    if (obj1.constructor.name !== obj2.constructor.name) return true;
    if (['String', 'Number', 'Boolean', 'Symbol'].includes(obj1.constructor.name)) {
      return obj1 !== obj2;
    }

    if (obj1.constructor.name !== 'Object') {
      if (typeof obj1.toString === 'function' && typeof obj2.toString === 'function') {
        return checkDiff(obj1.toString(), obj2.toString());
      }

      if (typeof obj1.valueOf === 'function' && typeof obj2.valueOf === 'function') {
        return checkDiff(obj1.valueOf(), obj2.valueOf());
      }

      return true;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return true;
    return keys1.some((key) => !keys2.includes(key) || checkDiff(obj1[key], obj2[key]));
  }

  return true;
}

// 等待获取到值
export async function waitValue(getValue, ms = 50) {
  const val = await getValue();
  if (!val) {
    await delay(ms);
    return waitValue(getValue, ms);
  }

  return val;
}

// 斜体替换
// eslint-disable-next-line max-statements
export function Italics(source) {
  try {
    const regHtml = /<[^>]/g;
    const regCurly = /{[^}]/g; // 判断是否指定英文
    const regDel = /^(\s|{)+|(\s|})+$/g; // 清除指定英文的花括号
    const regEnglish = /[a-zA-Z]/;
    // eslint-disable-next-line no-param-reassign
    source = regHtml.test(source) ? source.replace(/<.*?>/gi, '') : source;
    let Array;
    let start;
    let end;
    if (i18n.locale === 'zh-CN') {
      start = '<span style="display: inline-block;text-align: left">';
      end = '</span>';
      // Array = ['Mathematics and Physical Sciences', 'Biological and Biomedical Sciences'];
    } else {
      Array = ['The Program', '{Program}'];
      start = '<i>';
      end = '</i>';
    }
    if (i18n.locale === 'zh-CN') {
      if (regEnglish.test(source)) {
        return `${start}${source}${end}`;
      }
      return source;
    }
    Array.forEach((item) => {
      const reg = new RegExp(`${item}`, 'g');
      const The = `${start}${regCurly.test(item) ? item.replace(regDel, '') : item.trim()}${end}`;
      // eslint-disable-next-line no-param-reassign
      source = source.replace(reg, The);
    });

    return source;
    // eslint-disable-next-line id-length
  } catch (e) {
    // console.info(e);
  }
  return source;
}
// 获取aid唯一标识
export async function getAid() {
  // 某些情况下操作 localStorage 会报错.
  // try {
  //   let aid = await localStorage.getItem('AEGIS_ID');
  //   if (!aid) {
  //     aid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (cc) => {
  //       // eslint-disable-next-line no-bitwise
  //       const rs = (Math.random() * 16) | 0;
  //       // eslint-disable-next-line no-bitwise
  //       const vv = cc === 'x' ? rs : (rs & 0x3) | 0x8;
  //       return vv.toString(16);
  //     });
  //     localStorage.setItem('AEGIS_ID', aid);
  //   }
  //   return aid || '';
  // } catch (event) {
  //   return '';
  // }
  return '';
}

/**
 * 复制
 * @param name 复制内容
 * @param opts
 * @param opts.isI18n Boolean 是否使用  默认使用
 * @param opts.type String 提示类型  默认 success
 * @param opts.message String 复制成功提示内容
 */
export function getCopy(name, opts = {}) {
  return new Promise((resolve, reject) => {
    try {
      const oInput = document.createElement('input');
      oInput.value = name;
      oInput.readOnly = true;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      oInput.className = 'oInput';
      oInput.readOnly = 'readOnly'; // 防止ios聚焦触发键盘事件
      oInput.style.display = 'none';
      const optsNew = {
        isI18n: true,
        type: 'success',
        message: 'CopySuccessful',
        ...opts,
      };
      let message1;
      if (optsNew.isI18n) {
        message1 = i18n.t(optsNew.message);
      } else {
        message1 = optsNew.message;
      }
      MessagePlugin[optsNew.type](message1);
    } catch (err) {
      reject(err);
    }
    resolve();
  });
}

/**
 * 提示文案的字体修改
 * @param that 将this传入即可
 */
export function getNextTick(that) {
  that.$nextTick(() => {
    let className;
    if (that.isIos) {
      className = 'system-font-ios';
    } else {
      className = 'system-font-win';
    }
    const message = document.querySelector('.t-message__list .t-is-success');
    if (message) {
      message.classList.add(className);
    }
  });
}
// 判断ip类型
export function isIpv6(ip) {
  // eslint-disable-next-line prettier/prettier
  return /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/.test(ip);
}

// 分割字符
export const strWithSlice = (str, beginIndex, sign = '...') => {
  if (!str || typeof str !== 'string') return '';
  return str.length > beginIndex ? `${str.slice(0, beginIndex)}${sign}` : str;
};

// 前端分页
// eslint-disable-next-line max-len, prettier/prettier
export const paginationWithData = (data, pageSize, currentPage) => data.slice((currentPage - 1) * pageSize, pageSize * currentPage);

/*
      函数防抖
      @param {function} callback 回调函数
      @param {number} delay 间隔时间
      @param {boolean} ready 是否立即执行
     */
export const debounce = (callback, delay, ready = false) => {
  let timer = null;
  let timestamp = true;
  return function (...args) {
    if (ready && timestamp) {
      callback(...args);
      timestamp = false;
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback(...args);
      timestamp = true;
      timer = null;
    }, delay);
  };
};

/**
 * 节流函数：指定时间内只执行一次
 * @param {Function} fn 需执行的函数
 * @param {number} delay 时间间隔（毫秒）
 * @param {boolean} immediate 是否立即执行首次调用（默认true）
 */
export const throttle = (fn, delay = 500, immediate = true) => {
  let lastExecTime = 0; // 上次执行时间
  let timer = null; // 定时器

  return function (...args) {
    // eslint-disable-next-line no-invalid-this
    const context = this;
    const now = Date.now();

    // 立即执行模式（首次调用直接执行）
    if (immediate && !lastExecTime) {
      fn.apply(context, args);
      lastExecTime = now;
      return;
    }

    // 清除未执行的定时器
    if (timer) clearTimeout(timer);

    // 计算距离下次执行的剩余时间
    const remaining = delay - (now - lastExecTime);

    if (remaining <= 0) {
      // 时间间隔已到，执行函数
      fn.apply(context, args);
      lastExecTime = now;
    } else {
      // 设置定时器，保证末次触发也能执行
      timer = setTimeout(() => {
        fn.apply(context, args);
        lastExecTime = Date.now();
        timer = null;
      }, remaining);
    }
  };
};

// 获取窗口宽度
export const getScreenWidth = () => {
  let width = 0;
  if (window.innerWidth) {
    width = window.innerWidth;
  } else if (document.body && document.body.clientWidth) {
    width = document.body.clientWidth;
  }
  if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
    width = document.documentElement.clientWidth;
  }
  return { width };
};

// 获取当前时间戳
export const getTimestamp = () => {
  // 获取实时时间时间戳
  const currentDate = new Date().getTime();
  // 获取当前时间
  const currentTime = new Date(currentDate);
  // 获取当前年份
  const currentYear = currentTime.getFullYear();
  // 获取当前月份
  const currentMonth = currentTime.getMonth() + 1;
  // 获取当前日期
  const currentDay = currentTime.getDate();
  // 获取当前小时
  const currentHour = currentTime.getHours();
  // 获取当前分钟
  const currentMinute = currentTime.getMinutes();
  // 获取当前秒
  const currentSecond = currentTime.getSeconds();
  // 获取当前日期的时间戳
  const currentDateTimestamp = new Date(
    currentYear,
    currentMonth - 1,
    currentDay,
    currentHour,
    currentMinute,
    currentSecond,
  ).getTime();
  return currentDateTimestamp;
};

let grayStatusCache = null;

// 是否首页置灰
export const isHomeGray = async () => {
  if (grayStatusCache !== null) {
    return grayStatusCache;
  }
  try {
    // 获取首页配置
    const config = await fetchStatic(FETCH_LIST.HOME, true);
    // 配置不完整则不置灰
    const homeConfig = config?.homeConfig?.[0];
    if (!homeConfig) {
      grayStatusCache = false;
      return false;
    }
    return homeConfig.homepageGray === 'true';
  } catch (error) {
    // console.error('判断首页置灰状态时发生错误:', error);
    grayStatusCache = false;
    return false;
  }
};
// 数据万象图片处理方法
export const ImageProcessing = (path, data) => {
  /*
    data接收两个参数一个是类型，一个是尺寸（可能是宽度、高度）
    type: width 定宽 height 定高 maxWidth 宽为原图的size%  maxHeight 高为原图的size%
    imageMogr2/format/jpg 图片转换为jpg格式
    minsize/1 如果处理后图片体积大于原图，会返回原图不处理
    ignore-error/1 当处理参数中携带此参数时，针对文件过大、参数超限等导致处理失败的场景，会直接返回原图而不报错
  */
  if (!path) return;

  let url = path + '?imageMogr2/format/jpg/minsize/1/ignore-error/1';

  if (!data?.size) return url;

  switch (data?.type) {
    case 'width':
      url = `${url}/thumbnail/${data?.size}x`;
      break;
    case 'height':
      url = `${url}/thumbnail/x${data?.size}`;
      break;
    case 'maxWidth':
      url = `${url}/thumbnail/!${data?.size}px`;
      break;
    case 'maxHeight':
      url = `${url}/thumbnail/!x${data?.size}px`;
      break;
  }
  return url;
};
